import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Trip, TripStatus } from '../../models/trip';
import { TripsService } from '../../services/trips.service';
import { ToastsManager } from 'ng2-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-close-trips',
  templateUrl: './close-trips.component.html',
  styleUrls: ['./close-trips.component.css']
})
export class CloseTripsComponent implements OnInit {

  t : Trip;
  closeComment : string = "";

  @Output() onCloseValidation = new EventEmitter<boolean>();
  constructor(private tripService : TripsService, 
              private toast : ToastsManager,
              public activeModal : NgbActiveModal,
              public translate : TranslateService) { }

  ngOnInit() {
  }

  onConfirmClick() {
    this.tripService.closeAbnormally(this.t, this.closeComment).subscribe(res => this.onCloseValidation.emit(true));
    this.toast.success(this.translate.instant("toast.tripclosed"), this.translate.instant("toast.success"));
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/trips/close-trips/close-trips.component.ts